/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import React, { useRef } from "react"
import { Grid, Spacer, useMediaQuery } from "@cd2/components"
import { Hr } from "./Hr"
import { IComponentProp } from "../types/utils"
import { MultiButton } from "./MultiButton"
import { TextGroupMedium, TextGroupWithActions } from "./Title"

interface IProps {
  sidebar(): React.ReactNode
  children: React.ReactNode
  hideDetailsOnCompact?: boolean
  displayAsColumn?: boolean
}

export function PageSection({
  sidebar,
  children,
  hideDetailsOnCompact,
  displayAsColumn: displayAsColumnProp,
}: IProps) {
  const ref = useRef<HTMLDivElement>(null)
  const displayAsColumn = useMediaQuery({ maxWidth: 800 }, { ref }) || !!displayAsColumnProp
  return (
    <div
      ref={ref}
      css={css`
        padding: 16px 0;
      `}
    >
      <Grid columns={displayAsColumn ? ["auto"] : [300, "auto"]} gap={32}>
        {(!displayAsColumn || !hideDetailsOnCompact) && <div>{sidebar()}</div>}
        <div>{children}</div>
      </Grid>
      <Spacer size={32} />
      <Hr />
    </div>
  )
}

interface IPageSectionSidebar {
  heading: string
  body?: React.ReactNode
  actions?: IComponentProp<typeof MultiButton, "buttons">
  verticalActions?: boolean
}
export function PageSectionSidebar({
  actions,
  verticalActions,
  ...textProps
}: IPageSectionSidebar) {
  const theme = { heading: { color: "primary" }, body: { color: "default" } }
  return (
    <div>
      {actions ? (
        <TextGroupWithActions
          size="medium"
          actions={actions}
          verticalActions={verticalActions}
          {...textProps}
          theme={theme}
        />
      ) : (
        <TextGroupMedium {...textProps} theme={theme} />
      )}
    </div>
  )
}
